import React, {useState, useContext, useEffect} from 'react';
import { FieldProps } from 'formik'
import axios from 'axios';
import * as Sentry from '@sentry/react'

import UserContext from '../../contexts/user';
import FormikFieldCustomProps from "../field/formikfieldcustomprops";
import getEncodedImageUrl from '../get-encoded-image';
import ReactPlayer from "react-player";
import {Radio} from "./index";
import Checkbox from "./checkbox";
import useAxios from "axios-hooks";
import Swal from "sweetalert2";
import {flatten} from "lodash";
import SproutVideo from "../../components/sprout-video";

const QuestionVideoUpload: React.FC<FormikFieldCustomProps & FieldProps & {
    index:number,
    active_media:any
    mediaList:any
    onDataChange:Function,
    activeStatus:boolean,
    videoId:any
    videoToken:any
}> = ({
  field,
  form,

                                     index,
                                     active_media,
                                     mediaList,
                                     onDataChange,
                                     activeStatus,
                                     videoId,
                                     videoToken

}) => {
  const userContext = useContext(UserContext);
  const [uploading, setUploading] = useState(false);
    const [active,setActive]= useState(true)
    const [video_id,setVideoId]= useState("")
    const [video_token,setVideoToken]= useState("")
    const [localFile,setLocalFile]= useState("")

    //get event slung from url
    const slug = document.location.pathname.split("/")[1] || "invalid";
    // token value from cache for api calls
    let token: any = localStorage.getItem(`token-${slug}`);


    console.log("setMediaList INIT",mediaList[index],activeStatus);
    // update active /inactive checkbox based on change in mediaList
    useEffect(()=>{
        if(mediaList[index]?.image !== undefined && mediaList[index].image){
            if(!activeStatus){
                setActive(false)
            }

        }

    },[mediaList])

    // set data if already video is uploaded
    useEffect(() => {
        console.log("setMediaList INIT",mediaList[index],activeStatus);
        // check active video state
        if (activeStatus){
            setActive(true);
            setVideoToken(mediaList[index].videoToken);
            setVideoId(mediaList[index].videoId)
        }
    },[activeStatus])

    //api call for upload video to sprout video
    const [{ data, loading, error }, uploadVideo] = useAxios({
        url: "https://api.sproutvideo.com/v1/videos",

        method: "POST",
        data: {
            download_hd: true,
        },
    });

    // APi call for getting video token from dynamoDB
    const [{ loading: getVideoTokenLoading }, getVideoToken] = useAxios(
        {
            url: `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/get-video-token`,
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
        {
            manual: true,
        }
    );

    console.log("formData index",field)


    return (
    <div style={{display:'flex'}}>
      <label htmlFor={field.name} style={{ opacity: uploading ? 0.5 : 1, pointerEvents: uploading ? 'none' : 'all' }}>
      {
        // based on form data show image or placeholder image
        field.value
          ? localFile!="" ? <ReactPlayer url={localFile}  width='140px' height='80px'  controls={true} /> : <div style={{width:'140px' ,height:'80px'}}>
                <SproutVideo
                    id={videoId}
                    security_token={videoToken}
                    skip={0}
                    className="video-modal-content-first"
                    volume={1}

                    showcontrols={true}
                />
            </div>
          : <img height={35} width={35} src="/icons/video-camera.svg" alt="" className="upload-image-input" />
      }
      </label>
      <input id={field.name} type="file" className="d-none" accept="video/*" onChange={async (file) => {
        if(file.target.files && file.target.files.length === 1) {
          setUploading(true);
          const { name, type } = file.target.files[0];
          try {
              // check selected video size is less than 50mb
              if (file.target.files[0].size > 50e6) {
                  await Swal.fire({
                      title: "Please upload a file smaller than 50 MB",
                      icon: "error",
                  });
              }else{

                  //get video upload token for video
                  const response = await getVideoToken();
                  const fileToken = response.data;

                  // video form data
                  let formData = new FormData();
                  formData.append("source_video", file.target.files[0]);
                  formData.append("token", fileToken);

                  setLocalFile(URL.createObjectURL(file.target.files[0]));


                  console.log("formData",formData)

                  // api call
                  const videoUpload = await uploadVideo({
                      data: formData,
                      onUploadProgress : progressEvent => {
                          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                          //setProcessCount(percentCompleted);
                          console.log("formData",percentCompleted);
                      }
                  });
                form.setFieldValue(field.name, videoUpload.data.id);
                setVideoId(videoUpload.data.id);
                setVideoToken(videoUpload.data.security_token);
                // on data change callback for checkbox sync
                onDataChange("video",active,videoUpload.data.id,videoUpload.data.security_token)

                  console.log("formData",videoUpload);
              }

          } catch (e) {
              console.log("formData",e)
          }
          setUploading(false);
        }
      }} />
      {/*Delete image UI */}
      {field.value ?<div style={{marginLeft:'10px',cursor:'grab',display:'flex',flexDirection:'column'}} >

        <img
            title={"delete"}
            onClick={event => {
                form.setFieldValue(field.name, null);
            }
            }
          src="/icons/trash.svg"
          alt=""
          style={{height:'15px',cursor:'pointer'}}
      />
          {/*select active item for media display*/}
          <div className={`media-dev`} style={{marginTop:'6px',cursor:'pointer'}}>
              <input
                  id ="checkbox_id"
                  type="checkbox"
                  checked={active}
                  onChange={(e)=>{

                      // setActive(e.target.checked)}
              }}
              />
              <span className={'media-checkbox'} style={{paddingTop:'10px'}} onClick={(e)=>{
                  onDataChange("video",!active,video_id,video_token);
                  setActive(!active);

              }
              }></span>

          </div>

      </div>:""}
    </div>

  );
};


export default QuestionVideoUpload;
